import React from "react";
import { Button, Image, Typography } from "antd";
import verifySuccessIcon from "../../assets/img/icon-success.png";
import styles from "./signup.module.css";

const VerifySuccess = () => (
  <div className={styles.auth_signup_page}>
    <div className={styles.auth_wrapper}>
      <div className={styles.signup_success_wrapper}>
        <Image preview={false} src={verifySuccessIcon} />
        <Typography.Title level={3}>
          Email Verification Successful
        </Typography.Title>
        <Typography.Paragraph>
          Your account is verified and ready to use! Start your journey with us
          by signing in now.
        </Typography.Paragraph>
        <Button type="link" href="/signin" className={styles.btn_signup}>
          Sign In
        </Button>
      </div>
    </div>
  </div>
);

export default VerifySuccess;
